import MetricBox from "components-for/display/metric-box";
import useAgents from "hooks-for/agents/use-agents";
import { AgentStateType } from "@edgetier/watchtower-types";
import { faUserSlash } from "@fortawesome/pro-solid-svg-icons";
import { FunctionComponent, memo, useState } from "react";
import { getStartDateTime } from "./recently-offline-agents-metric.utilities";
import { IProps } from "./recently-offline-agents-metric.types";
import { LIVE_POLL_INTERVAL_MILLISECONDS } from "constants/pages/live";
import { MINUTES_INTERVAL } from "./recently-offline-agents-metric.constants";
import { parseUrlArray } from "@edgetier/utilities";
import { useInterval } from "react-use";
import { useQueryParameters } from "@edgetier/client-components";
import "./recently-offline-agents-metric.scss";

/**
 * Display how many agents have recently gone offline.
 * @returns Metric.
 */
const RecentlyOfflineAgentsMetric: FunctionComponent<IProps> = () => {
    const { tagId } = useQueryParameters({ tagId: parseUrlArray });
    const [startAgentStateUpdateDateTime, setStartAgentStateUpdateDateTime] = useState(getStartDateTime);
    const queryParameters = { agentStateType: AgentStateType.Offline, startAgentStateUpdateDateTime, tagId };
    const { data: agents, isLoading } = useAgents(queryParameters, { keepPreviousData: true });

    // Refresh the value periodically.
    useInterval(() => {
        setStartAgentStateUpdateDateTime(getStartDateTime());
    }, LIVE_POLL_INTERVAL_MILLISECONDS);

    return (
        <MetricBox
            icon={faUserSlash}
            isLoading={isLoading}
            title="Recently Offline Agents"
            tooltipContent={<>Agents that have gone offline in the current {MINUTES_INTERVAL} minute period</>}
            value={agents?.length ?? null}
        />
    );
};

export default memo(RecentlyOfflineAgentsMetric);
